const KEY = 'finderSearchSessionId';

// Compact base36 id (~12 chars) to keep the analytics username short.
const newId = (): string => Date.now().toString(36) + Math.random().toString(36).slice(2, 6);

/** Per-user (per-browser) id for `search_session_id`; survives tabs and restarts. */
export function getSearchSessionId(): string {
  try {
    const existing = localStorage.getItem(KEY);
    if (existing) return existing;
    const id = newId();
    localStorage.setItem(KEY, id);
    return id;
  } catch {
    // localStorage blocked (privacy mode).
    return newId();
  }
}
